import React, { useContext, useEffect, useState } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { CustomModal } from '@shared/ui';

import { AccountEditBody } from './AccountEditBody';
import { AccountEditFooter } from './AccountEditFooter';
import cls from './ModalEdit.module.css';
import {
    sumFormFormatter,
    sumFormFormatterWithNegative,
} from '../../../../shared/helpers/sumFormFormatter';
import { Context } from '../../Accounts';
import { fetchEditAccount, fetchIntegrationAccountListByCompany } from '../../accuntApi';

export const ModalEdit = ({ onShowModal }) => {
    const {
        modalState,
        accounts,
        setAccounts,
        currentList,
        employeelList,
        legalList,
        integrationList,
        setPopupMode,
        setIsShowPopup,
        isActiveSwitcherEdit: isActiveSwitcher,
        setIsActiveSwitcherEdit: setIsActiveSwitcher,
    } = useContext(Context);
    const { mode, isOpen, currentAccount } = modalState;

    const { t } = useTranslation();

    useEffect(() => {
        setIsActiveSwitcher(currentAccount.integration);
    }, []);

    const [integrationAccountList, setIntegrationAccountList] = useState({
        list: [],
        isLoading: false,
        datetime: '',
    });
    const initialFormState = {
        user: currentAccount.user_bind,
        title: currentAccount.title,
        account_number: currentAccount.account_number,
        opening_balance_value: sumFormFormatterWithNegative(
            String(currentAccount.opening_balance_value)
        ),
        date: new Date(currentAccount.opening_balance_date),
        integration: null,
        integrationAccount: currentAccount.integration ? currentAccount.account_number : null,
    };

    const [formState, setFormState] = useState(initialFormState);

    const [errors, setErrors] = useState({
        title: null,
        accountStartBalance: null,
        currency: null,
        legalEntity: null,
        accountInBank: null,
        integration: null,
    });

    const [currency, setCurrency] = useState(currentAccount.currency.id);
    const [legal, setLegal] = useState(
        currentAccount.user_bind ? currentAccount.user_bind.guid : null
    );
    const [employee, setEmployee] = useState(
        currentAccount.user_bind ? currentAccount.user_bind.email : null
    );
    const [checkbox, setCheckbox] = useState(currentAccount.default_account);

    const handleCurrencySelect = (value) => {
        setCurrency(value);
    };

    const onSwitcherChange = () => {
        if (currentAccount.avalible_delete !== true && !isActiveSwitcher) {
            setIsShowPopup(true);
            setPopupMode('edit');
        }
        setIsActiveSwitcher((prevState) => !prevState);
    };
    const formHandler = (event) => {
        const { name, value } = event.target;
        setFormState((prevState) => ({ ...prevState, [name]: value }));
    };

    const sumFormHandler = (event) => {
        const { name, value } = event.target;

        let formattedValue = sumFormFormatter(value);
        if (name === 'opening_balance_value') {
            formattedValue = sumFormFormatterWithNegative(value);
        }

        setFormState((prevState) => ({
            ...prevState,
            [name]: formattedValue,
        }));
    };

    const onCheckboxChange = () => {
        if (!currentAccount.default_account && !currentAccount.is_archive) {
            setCheckbox((prevState) => !prevState);
        }
    };

    const onDateChange = (newDate) => {
        setFormState((prevState) => ({ ...prevState, date: new Date(newDate) }));
    };

    const selectedMonth = currentList.find((item) => item.value == currency);
    const selectedLegal = legalList.find((item) => item.value == legal);
    const selectedEmployee = employeelList.find((item) => item.value == employee);

    const onCancelForm = () => {
        onShowModal();
        setFormState(initialFormState);
    };
    const onSubmitForm = () => {
        loader.show();
        const url = helpable.replaceUrlParameters(routable.getRoute('editCompanyAccount'), {
            _guid_: currentAccount.guid,
        });
        const formData = new FormData();
        const date = moment(formState.date).format('DD.MM.YYYY');
        formData.append('title', formState.title);
        formData.append('accountNumber', formState.account_number);
        formData.append('accountStartBalance', formState.opening_balance_value);
        formData.append('currency', currency);

        if (isActiveSwitcher) {
            formData.append('integration', formState.integration ? formState.integration : '');
            formData.append('accountStartDate', integrationAccountList.datetime);
        } else {
            formData.append('accountStartDate', date);
        }
        if (checkbox) {
            formData.append('isDefault', 1);
        }
        formData.append('submit', '1');

        const currentCurrency = currentList.find((option) => option.value == currency);
        const callback = (data) => {
            const editedAccount = {
                ...modalState.currentAccount,
                title: formState.title,
                account_number: formState.account_number,
                opening_balance_date: isActiveSwitcher
                    ? moment(integrationAccountList.datetime).format('YYYY-MM-DD')
                    : moment(formState.date).format('YYYY-MM-DD'),
                currency: currentCurrency.currency,
                default_account: checkbox,
                opening_balance_value: formState.opening_balance_value,
                current_balance: data.data.current_balance,
                integration: data.data.integration,
            };

            const newAccount = [...accounts];
            for (let i = 0; i < newAccount.length; i++) {
                if (checkbox) {
                    if (newAccount[i].default_account) {
                        const newEditedAccount = { ...newAccount[i], default_account: false };
                        newAccount[i] = newEditedAccount;
                    }
                }

                if (newAccount[i].guid === editedAccount.guid) {
                    newAccount[i] = editedAccount;
                }
            }
            setAccounts(newAccount);
            onShowModal();
        };

        const errorHandler = (data) => {
            const initialState = {
                title: null,
                accountStartBalance: null,
                currency: null,
                legalEntity: null,
                accountInBank: null,
                integration: null,
            };

            data.errors.forEach((error) => {
                initialState[error.name] = error.messages.toString();
            });

            setErrors(initialState);
        };

        fetchEditAccount(url, callback, formData, errorHandler);
    };

    const onIntegrationChange = (value) => {
        setIntegrationAccountList((prevState) => ({ ...prevState, isLoading: true }));
        setFormState((prevState) => ({ ...prevState, integration: value }));

        const url = helpable.replaceUrlParameters(
            routable.getRoute('getIntegrationAccountListByCompany'),
            {
                _integrationType_: value,
            }
        );

        const callback = (data) => {
            if (data.status === 'success') {
                const getIntegrationAccounts = data.data.map((account) => ({
                    shortNumber: account.account_number
                        ? account.short_account_number
                        : t('ModalEdit.return.callback.getIntegrationAccounts.shortNumber'),
                    startBalance: account.start_balance,
                    sign: '₽',
                    integrationAccounts: account,
                    value: account.account_number,
                }));
                setIntegrationAccountList((prevState) => ({
                    isLoading: false,
                    list: getIntegrationAccounts,
                    datetime: data.datetime,
                }));
            } else {
                setIntegrationAccountList((prevState) => ({
                    isLoading: false,
                }));
            }
        };

        const errorHandler = () => {
            setIntegrationAccountList((prevState) => ({
                list: [],
                isLoading: false,
                datetime: '',
            }));
        };

        fetchIntegrationAccountListByCompany(url, callback, errorHandler);
    };

    const onIntegrationAccountChange = (value) => {
        const currentAccount = integrationAccountList.list.find(
            (accuont) => accuont.value === value
        );

        setFormState((prevState) => ({
            ...prevState,
            integrationAccount: value,
            title: currentAccount.integrationAccounts.account_name,
            account_number: currentAccount.integrationAccounts.account_number,
            opening_balance_value: currentAccount.startBalance,
        }));
    };

    const selectedIntegration = integrationList.find((item) => item.value == formState.integration);
    const selectedIntegrationAccount = integrationAccountList.list.find(
        (item) => item.value == formState.integrationAccount
    );

    return (
        <>
            <CustomModal.Header>
                {t('ModalEdit.return.ModalHeader.text')}
                {currentAccount.is_archive && (
                    <span className={classNames(cls.archiveHeader)}>
                        {t('ModalEdit.return.ModalHeader.archiveHeader.text')}
                    </span>
                )}
            </CustomModal.Header>
            <AccountEditBody
                formHandler={formHandler}
                account={currentAccount}
                formState={formState}
                onCheckboxChange={onCheckboxChange}
                handleCurrencySelect={handleCurrencySelect}
                selectedMonth={selectedMonth}
                currentList={currentList}
                checkbox={checkbox}
                selectedEmployee={selectedEmployee}
                selectedLegal={selectedLegal}
                onDateChange={onDateChange}
                isActiveSwitcher={isActiveSwitcher}
                onSwitcherChange={onSwitcherChange}
                selectedIntegration={selectedIntegration}
                onIntegrationChange={onIntegrationChange}
                onIntegrationAccountChange={onIntegrationAccountChange}
                selectedIntegrationAccount={selectedIntegrationAccount}
                integrationAccountList={integrationAccountList}
                errors={errors}
                sumFormHandler={sumFormHandler}
            />
            <AccountEditFooter
                t={t}
                onCancel={onCancelForm}
                onSuccess={onSubmitForm}
                isArchive={currentAccount.is_archive}
            />
        </>
    );
};
